import { createAsyncThunk } from '@reduxjs/toolkit';
import { getOrderState } from 'src/api';
import { OrderState } from 'src/types/order';

import { TOrderStateError } from './types';

export const fetchOrderStateThunk = createAsyncThunk<
  OrderState,
  { paymentFormUniqueId: string },
  {
    rejectValue: TOrderStateError;
  }
>('fetchOrderStateThunk', async ({ paymentFormUniqueId }, thunkApi) => {
  try {
    const response = await getOrderState(paymentFormUniqueId);

    if (response.status === 'OK') {
      return response.payment_form_state;
    }

    if (response.error_code === 'ORDER_EXPIRED') {
      return thunkApi.rejectWithValue(response.error_code);
    }

    return thunkApi.rejectWithValue('UNKNOWN_ERROR');
  } catch {
    return thunkApi.rejectWithValue('UNKNOWN_ERROR');
  }
});
